
import Vue from 'vue';

export default Vue.extend({
    name: 'ProductBanner',
    data: () => ({}),
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
});
